<elder-single-pane-wrapper class="full">
  <div class="layout-row place-between-center pt-sm pl-md">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>{{ 'context.facility' | translate }}</mat-label>
      <elder-select
        appFacilitySelect
        name="facility"
        valueAsId
        [value]="facilityId$ | async"
        (valueChange)="facilityId = $event"
      ></elder-select>
    </mat-form-field>

    <button mat-button (click)="onSave($event)">
      <mat-icon>save</mat-icon>
    </button>
  </div>

  <elder-basic-pane-layout class="flex">
    <elder-pane class="outlined">
      <app-optimisation-schedule-detail
        class="flex"
        [facilityId]="facilityId$ | async"
        [requestSave]="requestSave.asObservable()"
      >
      </app-optimisation-schedule-detail>
    </elder-pane>

    <elder-pane class="outlined">
      <app-optimisation-day-browser
        class="flex"
        [facilityId]="facilityId$ | async"
        [requestSave]="requestSave.asObservable()"
      >
      </app-optimisation-day-browser>
    </elder-pane>
  </elder-basic-pane-layout>
</elder-single-pane-wrapper>
